import React, { useMemo, useState } from 'react';
import { useQuestionnairesQuery } from '../../../../graphql/graphql';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { FieldError } from 'react-hook-form';
import MultiSelectWithCheckList from '../../../Base/Components/Inputs/MultiSelectWithCheckList/MultiSelectWithCheckList';
import Loading from '../../../../Components/Loading';

interface Props {
	onChange?: (value: SelectValue) => void;
	workplaceId?: string;
	value?: SelectValue;
	error?: FieldError;
	placeholder?: string;
	portal?: boolean;
	isSearchable?: boolean;
}

const QuestionnaireMultiSelectWithCheckList: React.FC<Props> = props => {
	const { value, onChange, portal, isSearchable } = props;
	const [defaultValue, setDefaultValue] = useState<SelectValue | undefined>(
		value,
	);
	const { data, isLoading } = useQuestionnairesQuery({ take: 999 });

	const options: SelectValue[] = useMemo(() => {
		const items: SelectValue[] = [];

		data?.questionnaires?.data?.forEach(item => {
			if (item?.title && item?.id) {
				items.push({
					label: item.title,
					value: item.id,
				});
			}
		});

		return items;
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<MultiSelectWithCheckList
			{...props}
			options={options}
			onChange={onChange}
			value={defaultValue?.label ? defaultValue : value}
			portal={portal}
			isSearchable={isSearchable}
			showItemsCounting={false}
		/>
	);

	return null;
};

export default QuestionnaireMultiSelectWithCheckList;
